import React from 'react';
import { hasShapeContent } from 'pxc-editor-core/helpers/schema';
import PageShieldRenderer from './PageShieldRenderer';

const PageShieldsRenderer = props => {
  const {
    shieldsToRender,
    shieldsSelection,
    isContentPlacingDebugging,
    page,
    onShapeClick,
    isGridDisplayed,
    gridWidth,
    selRadius,
    selWizard,
  } = props;

  return (
    <>
      {shieldsToRender.map(shapeObj => (
        <PageShieldRenderer
          key={shapeObj.id}
          isSelected={shieldsSelection[shapeObj.id]}
          withMiddleLines={
            isContentPlacingDebugging && hasShapeContent(shapeObj, page)
          }
          onShapeClick={onShapeClick}
          isGridDisplayed={isGridDisplayed}
          gridWidth={gridWidth}
          selRadius={selRadius}
          shapeObj={shapeObj}
          useFineStrocke={!!selWizard}
        />
      ))}
    </>
  );
};

export default PageShieldsRenderer;
